<script>
import SelectorShelf from "./SelectorShelf.vue";

export default {
    components: {
        SelectorShelf
    },
    props: {
        // Rayons
        shelves: {
            type: Array,
            required: true
        }
    },
    data: function(){
        return {
            device: "accessory"
        }
    },
    computed: {
        isMultiShelf() {
            return this.shelves.length > 0
        }
    }
}
</script>

<template>
    <ul id="accessory-selector-shelves" class="items-list accordion">
        <li v-for="shelf in shelves" :key="shelf.seoId + '-' + device">
            <selector-shelf
                ref="selectorShelf"
                class="items-list-item"
                :device="device"
                :shelf-id="shelf.seoId + '-' + device"
                :label="shelf.label"
                :show-all-check-box="shelf.showAllCheckBox"
                :check-boxes="shelf.checkBoxes"
                :show="shelf.show"
                :is-multi-shelf="isMultiShelf"
                v-on="$listeners"
            />
        </li>
    </ul>
</template>
<style scoped lang="scss">

</style>

